/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupServiceGetManyResponse
 */
export interface GroupServiceGetManyResponse {
    /**
     * 
     * @type {Date}
     * @memberof GroupServiceGetManyResponse
     */
    timePeriodDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceGetManyResponse
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceGetManyResponse
     */
    groupName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GroupServiceGetManyResponse
     */
    originalEffectiveDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupServiceGetManyResponse
     */
    reissueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceGetManyResponse
     */
    requestStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceGetManyResponse
     */
    requestedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GroupServiceGetManyResponse
     */
    requestedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceGetManyResponse
     */
    assignedTo?: string | null;
}

/**
 * Check if a given object implements the GroupServiceGetManyResponse interface.
 */
export function instanceOfGroupServiceGetManyResponse(value: object): value is GroupServiceGetManyResponse {
    return true;
}

export function GroupServiceGetManyResponseFromJSON(json: any): GroupServiceGetManyResponse {
    return GroupServiceGetManyResponseFromJSONTyped(json, false);
}

export function GroupServiceGetManyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupServiceGetManyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'timePeriodDate': json['timePeriodDate'] == null ? undefined : (new Date(json['timePeriodDate'])),
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'originalEffectiveDate': json['originalEffectiveDate'] == null ? undefined : (new Date(json['originalEffectiveDate'])),
        'reissueDate': json['reissueDate'] == null ? undefined : (new Date(json['reissueDate'])),
        'requestStatus': json['requestStatus'] == null ? undefined : json['requestStatus'],
        'requestedBy': json['requestedBy'] == null ? undefined : json['requestedBy'],
        'requestedDate': json['requestedDate'] == null ? undefined : (new Date(json['requestedDate'])),
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
    };
}

export function GroupServiceGetManyResponseToJSON(json: any): GroupServiceGetManyResponse {
    return GroupServiceGetManyResponseToJSONTyped(json, false);
}

export function GroupServiceGetManyResponseToJSONTyped(value?: GroupServiceGetManyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timePeriodDate': value['timePeriodDate'] == null ? undefined : ((value['timePeriodDate']).toISOString()),
        'policyNumber': value['policyNumber'],
        'groupName': value['groupName'],
        'originalEffectiveDate': value['originalEffectiveDate'] == null ? undefined : ((value['originalEffectiveDate']).toISOString()),
        'reissueDate': value['reissueDate'] == null ? undefined : ((value['reissueDate']).toISOString()),
        'requestStatus': value['requestStatus'],
        'requestedBy': value['requestedBy'],
        'requestedDate': value['requestedDate'] == null ? undefined : ((value['requestedDate']).toISOString()),
        'assignedTo': value['assignedTo'],
    };
}

